import React from "react"
/* custom component */
import Header from "../../../component/Header/Header"
import { PageContainer, LayoutContainer } from "../../../component/Xcomponent"
import BulkUpload from "../../../component/BulkUpload/BulkUpload"

/* actions */

/* otehrs */

export const ContainerMasterBulkUpload = props => {
    /* variables */
    return (
        <>
            <Header
                backButton={"/container-master/list"}
                title={"Container Master Bulk Upload"}
            />
            <PageContainer>
                <LayoutContainer>
                    <BulkUpload master="containerMaster" backUrl="/container-master/list" apiUrl="container/bulk-upload" />
                </LayoutContainer>
            </PageContainer>
        </>
    )
}

export default ContainerMasterBulkUpload;